import { isConnected, OFFLINE_BAND_TEXT } from '../store/sync-view'
import { useUi } from '../store/ui'

/**
 * The persistent offline band: surface tone under the header, never a toast, never red.
 * Stays mounted so it can grow over 200 ms (grid-template-rows); the chip is the live region
 * that announces the change, so the band itself stays silent. Its sentence is in the page only
 * while the device is offline (uji B20, D7): folded away, it read as "Tidak terhubung" to
 * anything reading the page's text while the chip said Tersinkron.
 */
export function OfflineBand() {
  const sync = useUi((s) => s.sync)
  const online = useUi((s) => s.online)
  const offline = !isConnected(sync, online)
  return (
    <div className="band-grow" data-open={offline} aria-hidden={!offline} inert={!offline}>
      <div>
        {offline ? (
          <p className="border-b border-border bg-surface px-4 py-2 text-label text-text md:px-6 lg:px-8">
            {OFFLINE_BAND_TEXT}
          </p>
        ) : null}
      </div>
    </div>
  )
}
